import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2">
      <Button
        data-testid="language-switcher-it"
        variant={language === 'it' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => setLanguage('it')}
        className={language === 'it' ? 'bg-[#8A9A86] hover:bg-[#7A8A76]' : ''}
      >
        IT
      </Button>
      <Button
        data-testid="language-switcher-en"
        variant={language === 'en' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => setLanguage('en')}
        className={language === 'en' ? 'bg-[#8A9A86] hover:bg-[#7A8A76]' : ''}
      >
        EN
      </Button>
    </div>
  );
};
